import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Headline, BodyCopy } from '@xingternal/typography';
import { Button } from '@xingternal/button';
import * as Types from '@xingternal/pages-graphql-types';

import { useEditContext } from '@xingternal/pages-common';

import { PAGE_INFO_HELP_URL, XBM_URL } from '../../config';
import styles from './PageInfo.css';

type PageInfoProps = {
  contractType?: Types.EntityPageContractType | null;
  pageSlug: string;
};

const PageInfo = ({ contractType, pageSlug }: PageInfoProps) => {
  const { isEditor, isAdmin } = useEditContext();
  let flagKey = isAdmin
    ? 'EP_PAGE_INFO_ROLE_ADMINISTRATOR'
    : isEditor
    ? 'EP_PAGE_INFO_ROLE_EDITOR'
    : null;

  return (
    <>
      <Headline size={'xxxlarge'} className={styles.header}>
        <FormattedMessage id={'EP_PAGE_INFO_TITLE'} />
      </Headline>
      <div className={styles.headerDetail}>
        {flagKey && (
          <div className={styles.role}>
            <Headline size={'small'} className={styles.headerDetailLabel}>
              <FormattedMessage id={'EP_PAGE_INFO_ROLE_LABEL'} />
            </Headline>
            <span className={styles.flag}>
              <FormattedMessage id={flagKey} />
            </span>
          </div>
        )}
        {contractType && (
          <div className={styles.pageType}>
            <Headline size={'small'} className={styles.headerDetailLabel}>
              <FormattedMessage id={'EP_PAGE_INFO_PAGE_TYPE_LABEL'} />:
            </Headline>
            <span className={styles.flag}>
              <FormattedMessage id={'EP_PAGE_INFO_PAGE_TYPE_' + contractType} />
            </span>
          </div>
        )}
      </div>
      <div className={styles.mainArea}>
        <div className={styles.blockContainer}>
          <div>
            <Headline size={'large'} className={styles.blockHeader}>
              <FormattedMessage id={'EP_PAGE_INFO_MANAGE_TITLE'} />
            </Headline>
            <BodyCopy size={'small'} className={styles.blockBody}>
              <FormattedMessage id={'EP_PAGE_INFO_MANAGE_BODY'} />
            </BodyCopy>
          </div>
          <div>
            <Button
              variant={'secondary'}
              size={'small'}
              href={XBM_URL(pageSlug)}
              target={'_blank'}
            >
              <FormattedMessage id={'EP_PAGE_INFO_MANAGE_CTA'} />
            </Button>
          </div>
        </div>
        <div className={styles.blockContainer}>
          <div>
            <Headline size={'large'} className={styles.blockHeader}>
              <FormattedMessage id={'EP_PAGE_INFO_HELP_TITLE'} />
            </Headline>
            <BodyCopy size={'small'} className={styles.blockBody}>
              <FormattedMessage id={'EP_PAGE_INFO_HELP_BODY'} />
            </BodyCopy>
          </div>
          <div>
            <Button
              variant={'secondary'}
              size={'small'}
              href={PAGE_INFO_HELP_URL()}
              target={'_blank'}
            >
              <FormattedMessage id={'EP_PAGE_INFO_HELP_CTA'} />
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PageInfo;
